import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpaceService {
  apiUrl: string;

  spaceDataSubscription = new BehaviorSubject({});
  spaceMediaDataSubscription = new BehaviorSubject({});
  spaceErrorDataSubscription = new BehaviorSubject({});

  // Company data subscription
  companyDataSubscription = new BehaviorSubject({});
  // spaceDataSubscription = this.spaceSource.asObservable();

  // Space thumb upload
  spaceThumbUploadUrl: any;

  constructor(public router: Router, private http: HttpClient) {
    this.apiUrl = environment.apiUrl;
  }

  public upload(data, accessToken) {
    const headers = new HttpHeaders({
      Authorization: accessToken
    });
    const uploadURL = `${this.apiUrl}/member/space/fileupload`;

    return this.http.post<any>(uploadURL, data, {
      headers,
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };
        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }

  public reUploadObjMtlZip(data, accessToken) {
    const headers = new HttpHeaders({
      Authorization: accessToken
    });
    const uploadURL = `${this.apiUrl}/member/space/filereupload`;

    return this.http.post<any>(uploadURL, data, {
      headers,
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };
        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }



  public upload360Image(data, accessToken) {
    // const headers = new HttpHeaders({
    //   Authorization: accessToken,
    //   Accept: 'application/json'
    // });
    // const uploadURL = `${this.apiUrl}/member/space/fileupload`;
    // return this.http.post<any>(uploadURL, data, {headers});

    const headers = new HttpHeaders({
      Authorization: accessToken
    });
    const uploadURL = `${this.apiUrl}/member/space/fileupload`;

    // return this.http.post<any>(uploadURL, data, {
    //   headers,
    //   reportProgress: true,
    //   observe: 'events'
    // }).pipe(map((event) => {
    //   switch (event.type) {
    //     case HttpEventType.UploadProgress:
    //       const progress = Math.round(100 * event.loaded / event.total);
    //       return { status: 'progress', message: progress };
    //     case HttpEventType.Response:
    //       return event.body;
    //     default:
    //       return `Unhandled event: ${event.type}`;
    //   }
    // })
    // );

    return this.http.post(uploadURL, data, {
      headers,
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );

  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  public upload360Video(data, accessToken) {
    const headers = new HttpHeaders({
      Authorization: accessToken
    });
    const uploadURL = `${this.apiUrl}/member/space/fileupload`;

    return this.http.post<any>(uploadURL, data, {
      headers,
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };
        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }

  public uploadFlooplanImage(data, accessToken) {
    const headersData = new HttpHeaders({
      Authorization: `${accessToken}`
    });
    const uploadURL = `${this.apiUrl}/floorplan`;
    return this.http.post<any>(uploadURL, data, {headers: headersData});
  }

  updateFloorplanImage(accessToken, uuid, data) {
    const headersData = new HttpHeaders({
      Authorization: `${accessToken}`
    });
    const uploadURL = `${this.apiUrl}/floorplan/${uuid}`;
    return this.http.post<any>(uploadURL, data, {headers: headersData});
  }

  setSpaceData(data) {
    this.spaceDataSubscription.next(data);
  }

  setSpaceMediaData(data) {
    this.spaceMediaDataSubscription.next(data);
  }

  setSpaceErrorData(error) {
    this.spaceErrorDataSubscription.next(error);
  }

  uploadHotSpotInfoMedia(image, spaceMediaId, accessToken) {
    const headers = new HttpHeaders({
      Authorization: accessToken,
      // 'Content-Type': 'application/form-data',
    });

    const formData = new FormData();
    formData.append('file', image);
    formData.append('space_media_uuid', spaceMediaId);
    // return this.http.post(this.spaceThumbUploadUrl, formData, { headers });

    const uploadURL = `${this.apiUrl}/media/spaceinfo/fileupload`;
    return this.http.post<any>(uploadURL, formData, {headers});
  }

  // setMembersData(data) {
  //   this.spaceDataSubscription.next(data);
  // }

  // updateSpaceThumb(accessToken, image) {
  //   const headers = new HttpHeaders({
  //     Authorization: accessToken
  //   });
  //   const formData = new FormData();
  //   formData.append('image', image);
  //   return this.http.post(this.spaceThumbUploadUrl, formData, { headers });
  // }

  // public takeSnapshot(fileData, mediaId, accessToken) {
  //   const headers = new HttpHeaders({
  //     Authorization: accessToken,
  //   });
  //   const formData = new FormData();
  //   formData.append('image', fileData);
  //   formData.append('media_id', mediaId);
  //   const uploadURL = `${this.apiUrl}/snapshot`;
  //   return this.http.post<any>(uploadURL, formData, {headers});
  // }

  // public takeSnapshot(fileData, mediaId, accessToken) {
  //   const headers = new HttpHeaders({
  //     Authorization: accessToken
  //   });

  //   const formData = new FormData();
  //   formData.append('image', fileData);
  //   formData.append('media_id', mediaId);

  //   const uploadURL = `${this.apiUrl}/snapshot`;

  //   return this.http.post<any>(uploadURL, formData, {
  //     headers,
  //     reportProgress: true,
  //     observe: 'events'
  //   }).pipe(map((event) => {
  //     switch (event.type) {
  //       case HttpEventType.UploadProgress:
  //         const progress = Math.round(100 * event.loaded / event.total);
  //         return { status: 'progress', message: progress };
  //       case HttpEventType.Response:
  //         return event.body;
  //       default:
  //         return `Unhandled event: ${event.type}`;
  //     }
  //   })
  //   );
  // }

  public takeSnapshot(fileData, mediaId, coordinates, accessToken) {
    const headers = new HttpHeaders({
      Authorization: accessToken,
      Accept: 'application/json'
    });
    const formData = new FormData();
    formData.append('image', fileData);
    formData.append('media_id', mediaId);
    formData.append('coordinates', JSON.stringify(coordinates));
    const uploadURL = `${this.apiUrl}/snapshot`;
    return this.http.post<any>(uploadURL, formData, {
      headers,
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };
        case HttpEventType.Response:
          return event.body;
        // default:
        //   return `Unhandled event: ${event.type}`;
      }
    })
    );
  }

  setCompanyData(company) {
    this.companyDataSubscription.next(company);
  }

}
